export interface LoadingAndErrorState {
  isLoading: boolean;
  error: Record<string, string>;
}

export const initialLoadingAndErrorState: LoadingAndErrorState = {
  error: {},
  isLoading: false,
};
